module.exports = __webpack_public_path__ + "img/buy-sell.f84c974a.jpg";